import type { ModalInfo } from '@entities/info-modal';

export const ALL_CALLS = 'Все звонки';
export const MISSED_CALLS = 'Пропущенные';

export const resumeParkingModalLabels: ModalInfo = {
	modalText: 'Звонок будет снят с парковки и возобновится на текущем устройстве',
	applyButton: {
		text: 'Ответить',
		type: 'primary',
	},
	cancelButton: {
		text: 'Назад',
		type: 'secondary',
	},
};
